import useTabParam from '../../hooks/useTabParam'
import PageTitle from '../../components/PageTitle'
import LedgerList from './LedgerList'
import WeightMisCenter from './WeightMisCenter'
import MisUploadHistory from './MisUploadHistory'
import PillFilters from '../AppointmentDeliveriesV2/shared/PillFilters'

const PILLS = [
  { key: '1', label: 'Ledger' },
  { key: '2', label: 'MIS Upload' },
  { key: '3', label: 'Upload History' },
]

export default function WeightLedger() {
  const [view, setView] = useTabParam('1')
  return (
    <>
      <PageTitle>Weight Ledger</PageTitle>
      <PillFilters pills={PILLS} value={view} onChange={setView} />
      {view === '1' && <LedgerList />}
      {view === '2' && <WeightMisCenter />}
      {view === '3' && <MisUploadHistory />}
    </>
  )
}
